import { render, staticRenderFns } from "./AS_ProjectContent.vue?vue&type=template&id=27275801&scoped=true&"
import script from "./AS_ProjectContent.vue?vue&type=script&lang=js&"
export * from "./AS_ProjectContent.vue?vue&type=script&lang=js&"
import style0 from "./AS_ProjectContent.vue?vue&type=style&index=0&id=27275801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27275801",
  null
  
)

export default component.exports